import { useEffect } from 'react';

const SchemaOrg = ({ type, data }) => {
  useEffect(() => {
    const id = `schema-${type}-${Math.random().toString(36).slice(2, 8)}`;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [type, data]);
  return null;
};

export const LocalBusinessSchema = () => (
  <SchemaOrg
    type="LocalBusiness"
    data={{
      "@context": "https://schema.org",
      "@type": "HomeAndConstructionBusiness",
      "name": "Prime Adapt Seniors",
      "telephone": "+33970707069",
      "url": "https://prime-adapt-seniors.fr",
      "description": "Adaptation du logement pour le maintien à domicile des seniors. Accompagnement gratuit Ma Prime Adapt', installation douche senior, monte-escalier.",
      "priceRange": "€€",
      "areaServed": [
        { "@type": "State", "name": "Île-de-France" },
        { "@type": "AdministrativeArea", "name": "Oise (60)" },
        { "@type": "AdministrativeArea", "name": "Aisne (02)" }
      ],
      "serviceType": ["Adaptation du logement", "Maintien à domicile", "Rénovation salle de bain senior"],
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    }}
  />
);

export const ServiceSchema = ({ name, description, url }) => (
  <SchemaOrg
    type="Service"
    data={{
      "@context": "https://schema.org",
      "@type": "Service",
      "name": name,
      "description": description,
      "url": url,
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "Prime Adapt Seniors",
        "telephone": "+33970707069"
      },
      "areaServed": [
        { "@type": "State", "name": "Île-de-France" },
        { "@type": "AdministrativeArea", "name": "Oise (60)" },
        { "@type": "AdministrativeArea", "name": "Aisne (02)" }
      ]
    }}
  />
);

export const FAQSchema = ({ questions }) => (
  <SchemaOrg
    type="FAQPage"
    data={{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": questions.map(q => ({
        "@type": "Question",
        "name": q.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": q.answer
        }
      }))
    }}
  />
);

export const BlogPostSchema = ({ title, description, url, datePublished }) => (
  <SchemaOrg
    type="BlogPosting"
    data={{
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": title,
      "description": description,
      "url": url,
      "datePublished": datePublished,
      "author": { "@type": "Organization", "name": "Prime Adapt Seniors" },
      "publisher": { "@type": "Organization", "name": "Prime Adapt Seniors" }
    }}
  />
);

export default SchemaOrg;
